import React from 'react';
import { useStyles } from './styles/styles';
import ContentLoader from 'react-content-loader';

const Card = ({
  title,
  value,
  secondValue,
  borderLeftColor,
  backgroundColor,
  color,
  icon, 
  iconBackgroundColor,
  isLoading = false,
  secondValueLabel,
  firstValueLabel,
}) => {
  const classes = useStyles();

  return (
      <div
        className={classes.card}
        style={{ borderLeft: `8px solid ${borderLeftColor}`, backgroundColor }}
      >
        <div className={classes.contentTitle}>
          {icon && (
            <div className={classes.icon} style={{ backgroundColor: iconBackgroundColor }}>
              {icon}
            </div>
          )}
          <h1 className={classes.cardTitle}>{title}</h1>
        </div>

        <div className={classes.containerValue}>
          <div className={classes.contentValue}>
            {isLoading ? <Loading /> : <span style={{ color }} className={classes.cardValue}>{value}</span>}
            {secondValue && firstValueLabel && !isLoading && (
              <span className={classes.valueLabel}>{firstValueLabel}</span>
            )}
          </div>

          {secondValue && (
            <div className={classes.contentSecondValue}>
              {isLoading ? <Loading /> : (
                <>
                  {secondValueLabel && <span className={classes.valueLabel}>{secondValueLabel}</span>}
                  <span style={{ color }} className={classes.valueLabel}>{secondValue}</span>
                </>
              )}
            </div>
          )}
        </div>
      </div>
  );
};

export default Card;

const Loading = ({ width = 200, height = 30 }) => (
  <ContentLoader
    width={width}
    height={height}
    backgroundColor="#d6d6d6"
    foregroundColor="#e0e0e0"
    speed={2}
  >
    <rect x="0" y="0" rx="5" ry="5" width={width} height={height} />
  </ContentLoader>
);
